import { createFileRoute } from '@tanstack/react-router';
import { PageShell } from '@/ui/layout';
import { CapturaVisita } from '@/modules/agronomia/visita/components/CapturaVisita';

export const Route = createFileRoute('/_authed/agronomia_/visita')({
  validateSearch: (s: Record<string, unknown>): { imovel?: number } => {
    const raw = s.imovel;
    const n = typeof raw === 'number' ? raw : typeof raw === 'string' && /^\d+$/.test(raw) ? Number(raw) : undefined;
    return n ? { imovel: n } : {};
  },
  component: VisitaCapturaPage,
});

function VisitaCapturaPage() {
  const { imovel } = Route.useSearch();
  return (
    <PageShell eyebrow="Agronomia" title="Visita técnica" lead="Capture fotos por talhão — funciona offline e sincroniza depois.">
      {imovel ? (
        <CapturaVisita imovelId={imovel} />
      ) : (
        <p className="text-sm text-text-muted">Selecione uma fazenda no módulo Agronomia para iniciar a visita.</p>
      )}
    </PageShell>
  );
}
